import { httpsCallable } from "firebase/functions";

import { cloudFunctions } from "./getFunctions";
import {
  LoginCodigoMailEnviar,
  CloudFunctionResponse,
  CallablesGeneral
} from "@fixeduy/restaurantestypes";

const loginCodigoMailEnviar = async (
  data: LoginCodigoMailEnviar
): Promise<CloudFunctionResponse> => {
  const run = httpsCallable<CallablesGeneral, CloudFunctionResponse>(
    cloudFunctions,
    "callablesGenerales"
  );
  const result = await run({
    func: "loginCodigoMailEnviar",
    params: data
  });
  return result.data;
};

export { loginCodigoMailEnviar };
